// extracted by mini-css-extract-plugin
module.exports = {"loadingFullScreen":"styles_loadingFullScreen__lwVwd","loader":"styles_loader__3r9BA","text":"styles_text__NbmnM"};